import React, { useContext } from 'react';
import AloSidebar from 'src/scripts/templates/_shared/ui-components/YogaUI/alo-ui/AloSidebar';
import { ProductContext } from '../../ProductContext';
import { IColorwayProductData } from '../../types/PDP';
import { IStoreAvailabilityData } from './FindInStore';
import FindInStoreForm from './FindInStoreForm';
import FindInStoreTile from './FindInStoreTile';
import { pluralize } from 'src/scripts/utils/helpers';

const FindInStoreModal = ({
  product,
  storesData,
  size,
  userCountry,
  setLatLongLocalStorage,
  findInStorePricingDisclaimer,
  findInStoreApiError,
  setLastValidZip,
  lastValidZip,
}: {
  product: IColorwayProductData;
  storesData: IStoreAvailabilityData[];
  size?: string;
  userCountry: string;
  setLatLongLocalStorage: (data: string) => void;
  findInStorePricingDisclaimer: string;
  findInStoreApiError: boolean;
  setLastValidZip: (data: string) => void;
  lastValidZip: string;
}) => {
  const postalCodeToDisplay = lastValidZip !== '""' ? lastValidZip : 'you';

  const { isFindInStoreModalOpen, toggleFindInStoreModal } = useContext(ProductContext);

  return (
    <AloSidebar
      title={'Find A Store Near You'}
      headerBorder={true}
      visible={isFindInStoreModalOpen}
      onClose={() => toggleFindInStoreModal(false)}
      desktopWidth={730}
    >
      <div className="find-in-store-modal d-flex">
        <div className="find-in-store-modal-product d-flex">
          {product.images && (
            <div className="find-in-store-product-image">
              <img src={product?.images[0] ? product?.images[0] : product?.images[1]} alt={product.title}></img>
            </div>
          )}
          <div className="find-in-store-modal-product-text d-flex">
            {product.title && <p className="find-in-store-product-title editorial">{product.title}</p>}
            <div className="find-in-store-product-variants">
              {product.colorName && (
                <p>
                  <span>Color:</span> {product.colorName}
                </p>
              )}
              {size && (
                <p>
                  <span>Size:</span> {size}
                </p>
              )}
            </div>
          </div>
        </div>
        <div className="find-in-store-modal-form d-flex">
          <h5 className="h5">Check Nearby Inventory</h5>
          <FindInStoreForm
            userCountry={userCountry}
            setLatLongLocalStorage={setLatLongLocalStorage}
            findInStoreApiError={findInStoreApiError}
            setLastValidZip={setLastValidZip}
          />
          {storesData && storesData.length > 0 ? (
            <>
              <div className="find-in-store-modal-results d-flex">
                <p className="find-in-store-modal-results__store-count">
                  {pluralize(storesData.length, `store`)} found near {postalCodeToDisplay}
                </p>
                {findInStorePricingDisclaimer ? (
                  <p className="find-in-store-pricing-disclaimer black-text">{findInStorePricingDisclaimer}</p>
                ) : null}
              </div>
              <div className="find-in-store-tile-modal-container d-flex">
                {storesData.map((storeAvailabilityData: IStoreAvailabilityData) => {
                  return <FindInStoreTile store={storeAvailabilityData} displayMode={'modal'} />;
                })}
              </div>
            </>
          ) : (
            <p className="find-in-store-no-results">
              Sorry, there are no Alo stores found near you. Try a different ${userCountry === 'US' ? `zip` : `postal`}{' '}
              code.
            </p>
          )}
        </div>
      </div>
    </AloSidebar>
  );
};

export default FindInStoreModal;
